//Services
import { getImageByCurrentId } from "@/app/components/profile/service/profile.service";

export default {
    namespaced: true,
    state: {
        image: null
    },
    mutations: {
        set_user_image(state, passedUserImage) {
            if(passedUserImage) {
                state.image = passedUserImage
            }
        }
    },
    actions: {
        SET_USER_IMAGE({commit}, passedUserImage) {
            commit('set_user_image', passedUserImage)
        },
        GET_USER_IMAGE({commit}) {
            return new Promise( (resolve, reject) => {
                    getImageByCurrentId()
                        .then( success => {
                                resolve(success.data.image)
                            }
                        )
                        .catch( error => {  
                                reject(error)
                            }
                        )
                }
            )
        }
    },
    getters: {
        get_userImage: state => state.image
    }
}